/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-10-23T09:57:30.92
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getHrProjectParamsEditInit,
	getHrProjectParamsView
} from '@api/rentmanage/HrProjectParams';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getHrProjectParamsEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHrProjectParamsEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHrProjectParamsView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHrProjectParamsView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
